import * as React from "react";
import type { SVGProps } from "react";

const FacilityRecreationArea = React.memo((props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    focusable="false"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.33334 17.4997H6.53156C7.12966 17.4997 7.6819 17.1792 7.97864 16.6599L14.1654 5.83301H9.53122C8.93313 5.83301 8.38089 6.15349 8.08416 6.67277L2.6098 16.2529C2.46241 16.5108 2.46347 16.8277 2.61258 17.0846C2.76168 17.3415 3.03628 17.4997 3.33334 17.4997Z"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.4987 17.5V8.75"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.4987 17.4997V5.83301"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.668 5.83333V3.75C11.668 3.05964 11.1083 2.5 10.418 2.5V2.5C9.72761 2.5 9.16797 3.05964 9.16797 3.75V5.83333"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.5 9.16667H12.5"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.5 12.4997H12.5"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.5 15.8337H12.5"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.5 5.83333V3.75C17.5 3.05964 16.9404 2.5 16.25 2.5V2.5C15.5596 2.5 15 3.05964 15 3.75V5.83333"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.168 5.83366H17.5013"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
FacilityRecreationArea.displayName = "FacilityRecreationArea";

export default FacilityRecreationArea;
